<div class="flex flex-col">
  <nz-form-label [nzRequired]="props.required" nzFor="key">{{ props.label }}</nz-form-label>
  <div class="flex items-center" style="min-height: 32px;">
    <nz-switch [disabled]="to.disabled" [required]="props.required" [formControl]="formControl" [formlyAttributes]="field"></nz-switch>
  </div>
</div>
